<mat-dialog-content class="image-modal">
  <img #origin aria-hidden="true" class="image-modal__hidden-image" />
  <canvas #canvas></canvas>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <label>{{ 'general.label.zoom' | translate }}</label>
  <mat-slider
    [attr.aria-label]="'general.label.zoom' | translate"
    [displayWith]="zoomLabel"
    color="primary"
    discrete="true"
    max="100"
    min="10"
    showTickMarks="false"
    step="10">
    <input (valueChange)="zoom($event)" matSliderThumb value="100" />
  </mat-slider>

  <button
    (click)="rotate('left')"
    [attr.aria-label]="'image_preview.a11y.rotate_left' | translate"
    mat-icon-button
    title="{{ 'image_preview.a11y.rotate_left' | translate }}">
    <mat-icon>rotate_left</mat-icon>
  </button>
  <button
    (click)="rotate('right')"
    [attr.aria-label]="'image_preview.a11y.rotate_right' | translate"
    mat-icon-button
    title="{{ 'image_preview.a11y.rotate_right' | translate }}">
    <mat-icon>rotate_right</mat-icon>
  </button>

  @if (dialogData?.editMode) {
    <button (click)="close()" color="primary" mat-flat-button>
      {{ 'general.button.save' | translate }}
    </button>
  }
  <button (click)="close()" color="warn" mat-flat-button>{{ 'general.button.close' | translate }}</button>
</mat-dialog-actions>
